var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"variables-info"},[_c('p',{staticClass:"variables-info__title"},[_vm._v(" Добавьте в ваш документ переменные и загрузите готовый файл в программу")]),_c('button',{staticClass:"variables-info__btn-download",attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v("Переменные ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }